module.exports = __webpack_public_path__ + "img/logo_微信小程序(测试专用).af107068.png";